import {ShopPhone} from "./ShopPhone";
import {Shop, SHOP_TYPE} from "@/entities/shop";
import {Button} from "@/shared/ui/Button";
import styles from "./ShopCard.module.scss";

type Props = {
    shop: Shop;
    onShowOnMap: (shop: Shop) => void;
};

export const ShopCard = (
    {
        shop,
        onShowOnMap,
    }: Props
) => {
    const hasSchemaOrg = shop.tip === SHOP_TYPE.BRANDED;

    return (
        <div
            id={String(shop.id)}
            className={styles.item}
            {...(hasSchemaOrg && {
                itemScope: true,
                itemType: "https://schema.org/Organization",
            })}
        >
            <p
                className={styles.title}
                {...(hasSchemaOrg && {
                    itemProp: "name",
                })}
            >
                {shop.name}
            </p>

            <p
                className={styles.address}
                {...(hasSchemaOrg && {
                    itemProp: "address",
                    itemScope: true,
                    itemType: "https://schema.org/PostalAddress",
                })}
            >
                {shop.address}
                {shop.metro && `, ${shop.metro}`}
            </p>

            <ShopPhone
                phone={shop.phone}
                itemProp={hasSchemaOrg ? "telephone" : undefined}
            />

            {shop.operating_mode && (
                <p className={styles.operatingMode}>
                    Время работы: {shop.operating_mode}
                </p>
            )}

            <Button
                className={styles.link}
                variant={`secondary`}
                onClick={() => onShowOnMap(shop)}
            >
                Показать на карте
            </Button>
        </div>
    );
};
